import React from 'react'
import classNames from 'classnames'
import DateFormat from '../../../../shared/helpers/date-format'

let { iso8601, fullDay, weekDay, dayOfMonth } = DateFormat

const Header = ({ date, isToday }) => {
  return (
    <h2>
      <time
        dateTime={iso8601(date)}
        className={classNames('block text-14', {
          'text-white': isToday
        })}
      >
        <span className="sr-only">{fullDay(date)}</span>

        <span
          className="font-bold text-18 lg:hidden"
          aria-hidden="true"
        >
          {fullDay(date)}
        </span>

        <span
          className="hidden lg:block"
          aria-hidden="true"
        >
          {weekDay(date)}

          <span
            className={classNames('block font-bold lg:text-56', {
              'text-depths': !isToday,
              'text-white': isToday
            })}
          >
            {dayOfMonth(date)}
          </span>
        </span>
      </time>
    </h2>
  )
}

export default Header
